export { default } from "./useHasFeature";
